module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"placeholder":"View the latest report of your organization via names, website, subdomain name"},"nl":{"placeholder":"Direct naar het rapport via de organisatienaam of domeinnaam"}}')
  delete Component.options._Ctor
}
